import React, { useEffect, useState } from 'react';
import { IconButton, Text } from 'react-native-paper';
import EquipeBlack from "../../../image/equipe_preta.svg"
import api from '../../../services/api';

function Team({id}) {
    const [nomeEquipe, setNomeEquipe] = useState({
        motorista: "",
        coletor: "",
        coletor2: "",
        status: false,
    })
    useEffect(() => {
        const loadTeam = (id) => {
            api.get(`/clients/team/` + id,{
            }).then(function (response) {
                let { data, status } = response.data;
                if(status){
                    setNomeEquipe({
                        motorista: data.motorista,
                        coletor: data.ajudante1?.nome,
                        coletor2: data.ajudante2?.nome,
                        status
                    })
                }else{
                    setNomeEquipe({
                        motorista: "",
                        coletor: "",
                        coletor2: "",
                        status: false,
                    })
                }
            }).catch(function(error){
                console.log(error)
            });
        }
        loadTeam(id);
    }, [id])
    const [equipe, setEquipe] = useState(false);
    const showEquipe = () => {
        setEquipe(!equipe);
    }
    return (
        nomeEquipe.status && (
            <div 
            onClick={showEquipe}
            style={{backgroundColor: "var(--main-secondy25)", borderRadius: 20, marginLeft: "11%", marginRight: "11%",  marginBottom: 20, cursor: "pointer"}}>
                <div style={{alignItems: "center", flexDirection: 'row', justifyContent: 'flex-start', display: "flex"}}>
                    <IconButton size={27} 
                    icon={({ size}) => ( <img
                        src={EquipeBlack}
                        height={size}
                        className="d-inline-block align-top"
                        alt="Icone"
                        style={{height: size}}
                        />
                    )} 
                    style={{marginLeft: 10, marginRight: 0, marginTop: 0}} />
                    <Text style={{marginLeft: 10, marginTop: 0}}>Informações sobre a equipe de coleta</Text>
                </div>
                {equipe && (
                    <div style={{flexDirection: 'column', justifyContent: 'flex-start', marginLeft: 20, marginBottom: 10, display: "flex"}}>
                        <Text style={{marginTop: 0}}>Motorista: {nomeEquipe.motorista}</Text>
                        <Text style={{marginTop: 10}}>Coletor: {nomeEquipe.coletor}</Text>
                        <Text style={{marginTop: 10}}>Coletor: {nomeEquipe.coletor2}</Text>
                    </div>
                )}
            </div>
        )
    );
}

export default Team;